var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.49 12.25V14H20V15.5H14.49V17.25L12 14.75L14.49 12.25ZM9.5 2C9.5 3.1 8.6 4 7.5 4C6.4 4 5.5 3.1 5.5 2C5.5 0.9 6.4 0 7.5 0C8.6 0 9.5 0.9 9.5 2ZM1 21.5L3.75 7.4L2 8.15V11.5H0V6.8L5.25 4.65C5.5 4.55 5.75 4.5 6 4.5C6.7 4.5 7.35 4.85 7.7 5.45L8.65 7.05C9.55 8.5 11.15 9.5 13 9.5V11.5C10.8 11.5 8.85 10.5 7.55 8.9L6.95 11.9L9 13.95V21.5H7V15.5L4.85 13.5L3.1 21.5H1ZM12 17.75H17.51V16L20 18.5L17.51 21V19.25H12V17.75Z",
    fill: "#ED6E18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkIcon);
export default __webpack_public_path__ + "static/media/walk-icon.7dfd580338eb17c4169236eeff494480.svg";
export { ForwardRef as ReactComponent };